import styled from 'styled-components';

const DollarIconBorder = styled.path`
  fill: none;
  stroke: ${(props) => props.theme.color.primary.v400};
  stroke-width: 2px;
`;

const StrikeThrough = styled.rect`
  fill: ${(props) => props.theme.color.primary.v200};
`;

const DollarIconS = styled.path`
  fill: ${(props) => props.theme.color.primary.v200};
`;

const DollarIconWrapper = styled.svg`
  width: 30px;
  height: 30px;
`;

export { DollarIconWrapper, DollarIconS, DollarIconBorder, StrikeThrough };
